// import { useMemo } from 'react';
import { useMemo } from 'react';
import Button from 'components/Button';
import { useScreenSize, useTranslation } from 'services/hooks';
import './style.css';

const Pagination = ({
	currentChapter,
	handleUpdateChapter,
	totalChapters,
	chapterOrderInCourse,
	disabledNextChpater = false,
	allowMoveToPrevChapter = false,
	nextChapterTitle = 'Next chapter',
	prevChapterTitle = 'Previous chapter',
	children,
}) => {
	const MOBILE_SIZE = process.env.REACT_APP_MOBILE_SIZE;
	// const TABLET_SIZE = process.env.REACT_APP_TABLET_SIZE;
	const screenSize = useScreenSize();
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'pagination';

	const disablePrevButton = useMemo(() => {
		if (!allowMoveToPrevChapter) return chapterOrderInCourse === 1;
		return !allowMoveToPrevChapter;
	}, [allowMoveToPrevChapter, chapterOrderInCourse]);
	// const chapterNumbers = Array.from(Array(totalChapters), (_, index) => index + 1);

	// var _renderTab = chapter => (
	// 	<div
	// 		key={chapter}
	// 		className={`Pagination__item ${currentChapter === chapter ? 'Pagination__item--active' : ''}`}
	// 		onClick={() => handleUpdateChapter(chapter)}
	// 	>
	// 		chapter {chapter}
	// 	</div>
	// );

	//if chapters numbers will needed uncomment bellow <- 1 chapter 2 chapter 3 chapter 4 chapter 5 chapter 6 chapter 7 chapter 8 ->

	// const _renderList = useMemo(() => {
	// 	if (screenSize.width > TABLET_SIZE) {
	// 		//if the list is less then 11 return it all
	// 		if (chapterNumbers.length <= 11) return chapterNumbers.map(_renderTab);
	// 		//else retrun slice of only 10
	// 		// return chapterNumbers.slice(currentChapter-10 > 1 ? currentChapter - 2 : currentChapter - 1, currentChapter + 1).map(_renderTab);
	// 		var n = 6;
	// 		var start = Math.max(0, Math.min(Math.floor(currentChapter - n / 2), chapterNumbers.length - n));
	// 		return chapterNumbers.slice(start, start + n).map(_renderTab);
	// 	} else if (screenSize.width > MOBILE_SIZE) {
	// 		//slice only latets 3 elements for tablet
	// 		return chapterNumbers.slice(currentChapter > 1 ? currentChapter - 2 : currentChapter - 1, currentChapter + 1).map(_renderTab);
	// 	}
	// 	return _renderTab(currentChapter);
	// }, [screenSize.width, chapterNumbers]);

	return (
		<div className="Pagination">
			<Button
				small
				type="outline"
				startIcon="rightArrow"
				title={screenSize.width > MOBILE_SIZE ? getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_previous`) || prevChapterTitle : ''}
				onClick={() => handleUpdateChapter(currentChapter - 1)}
				disabled={disablePrevButton}
				extraClassName="Pagination__start"
			/>
			{/* <div className="Pagination__wrapper">{_renderList}</div> */}
			{children && children}
			<Button
				small
				type="outline"
				title={screenSize.width > MOBILE_SIZE ? getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_next`) || nextChapterTitle : ''}
				endIcon="rightArrow"
				onClick={() => handleUpdateChapter(currentChapter + 1)}
				disabled={chapterOrderInCourse === totalChapters || disabledNextChpater}
				extraClassName={`Pagination__end ${disabledNextChpater ? 'Pagination__disabled' : ''}`}
			/>
		</div>
	);
};

export default Pagination;
